// Dynamic styles based on theme - to be used with useThemedStyles.
export const createTicketListItemStyles = ({ ui: { colors, type, space, radius, touch } }) => ({
	card: {
		marginHorizontal: space.gutter,
		marginBottom: space.md,
		padding: 14,
		gap: 10,
		borderRadius: radius.hero,
		backgroundColor: colors.card,
	},
	topRow: {
		flexDirection: 'row',
		alignItems: 'center',
		justifyContent: 'space-between',
		gap: space.sm,
	},
	identifier: {
		...type.caption,
		color: colors.textSecondary,
		flexShrink: 1,
	},
	machineRow: {
		minHeight: touch.min,
		flexDirection: 'row',
		alignItems: 'center',
		gap: space.xs,
	},
	machineName: {
		...type.bodySmallStrong,
		color: colors.text,
		flexShrink: 1,
	},
	machineNameLink: {
		color: colors.accent,
	},
	pressed: {
		opacity: 0.7,
	},
	ticketDescription: {
		...type.sectionTitle,
		color: colors.text,
	},
	secondaryText: {
		...type.secondary,
		color: colors.textSecondary,
	},
	notes: {
		gap: space.sm,
	},
	note: {
		flexDirection: 'row',
		alignItems: 'center',
		justifyContent: 'space-between',
		gap: space.sm,
		paddingLeft: space.md,
		borderRadius: radius.control,
		backgroundColor: colors.raised,
	},
	noteDescription: {
		...type.secondary,
		color: colors.textSecondary,
		flex: 1,
		// Lets long links wrap inside the card on web instead of widening the row.
		minWidth: 0,
		paddingVertical: space.sm,
	},
	editNote: {
		minHeight: touch.min,
		justifyContent: 'center',
		paddingHorizontal: space.md,
	},
	editNoteLabel: {
		...type.secondaryStrong,
		color: colors.accent,
	},
	disabledText: {
		color: colors.disabledText,
	},
	photoRow: {
		flexDirection: 'row',
		flexWrap: 'wrap',
		gap: space.sm,
	},
	photo: {
		height: 72,
		width: 72,
		borderRadius: radius.control,
		backgroundColor: colors.chip,
		resizeMode: 'cover',
	},
	pendingSyncNote: {
		...type.caption,
		color: colors.warning,
	},
	resolutionBlockerText: {
		flex: 1,
		flexShrink: 1,
	},
	buttonRow: {
		flexDirection: 'row',
		gap: space.sm,
	},
	buttonGrid: {
		flexDirection: 'row',
		flexWrap: 'wrap',
		gap: space.sm,
	},
	gridButton: {
		flexGrow: 1,
		flexBasis: '40%',
	},
	compactButton: {
		minHeight: touch.compactButton,
	},
});
